import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost } from './helpers/axiosHelper';

import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();

// checking query params for transition result alert













const rulesCollectionNameInput = byId('rulesCollectionNameInput');

const addNewRulesCollectionSubmitBtn = byId('addNewRulesCollectionSubmitBtn');







const addNewRulesCollectionFun = () => {
    const formData = {
        name: rulesCollectionNameInput.value
       
    };
    callTheBaseServerPost(`/basic/addNewRulesCollection`, { data: formData }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'RulesCollection added',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

addNewRulesCollectionSubmitBtn.addEventListener('click', addNewRulesCollectionFun);

const deleteRulesCollectionsFun = (sn) =>{
    callTheBaseServerGet(`/basic/deleteRulesCollection/${sn}`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;

        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'RulesCollection Deleted',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error)=>{
        axiosErrorHandler(error);
        console.log(error);
    });
};


window.deleteRulesCollectionsFun=deleteRulesCollectionsFun;

// get wallet history



const getRulesCollectionsFun = () => {


    callTheBaseServerGet(`/basic/getRulesCollections`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




        const rulesCollectionTableBodyElement = byId('rulesCollectionTableBodyElement');
        const rulesCollectionTableNoDataRowElement = byId('rulesCollectionTableNoDataRowElement');

        if (res.status === 'success') {
            console.log(res);

            const rulesCollectionsData = res.rulesCollectionsData;
            let i = 0;





            if (rulesCollectionsData.length > 0) {

                addDNoneClass(rulesCollectionTableNoDataRowElement, true);


                while (i < rulesCollectionsData.length) {
                    const {sn, name} = rulesCollectionsData[i];

                    rulesCollectionTableBodyElement.innerHTML +=`
                    <tr>
                    
                        <td>${i + 1}</td>
                    
                        <td>${name}</td>
                        <td><button class="btn btn-primary" onclick="location.href='./rules.html?collectionId=${sn}'" >View Rules</button></td>
                     
                        <td><button class="btn btn-danger" onclick="deleteRulesCollectionsFun(${sn})" >Delete</button></td>
                      
                    </tr>
                    `;
                    i++;
                }
            }

            if (rulesCollectionsData.length === 0) {
                rulesCollectionTableNoDataRowElement.innerHTML = `
                <th class='text-center' colspan='6'>No Rules Collection Found 😥</th> 
                `;




            }



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

getRulesCollectionsFun();




